import { gql, useQuery } from "@apollo/client";
import { RoleType, UserStatus } from "../types";

export const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    currentUser {
      id
      emailAddress
      status
      gandalfDetails {
        vibeId
      }
    }
  }
`;
// The skip option prevents the GraphQL query from executing when user credentials
// haven't been loaded yet, avoiding unnecessary unauthorized responses
export const useGetCurrentUser = (options?: { skip?: boolean }) => {
  return useQuery(GET_CURRENT_USER, {
    ...options,
  });
};

export interface CurrentUserQueryResponseData {
  id: string;
  emailAddress: string;
  status: UserStatus;
  gandalfDetails: {
    vibeId: string;
  };
}
